import { render, staticRenderFns } from "./SkribbleFormK.vue?vue&type=template&id=003584cf&scoped=true&"
import script from "./SkribbleFormK.vue?vue&type=script&lang=js&"
export * from "./SkribbleFormK.vue?vue&type=script&lang=js&"
import style0 from "./SkribbleFormK.vue?vue&type=style&index=0&id=003584cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003584cf",
  null
  
)

export default component.exports